import React, { Component } from 'react'
import { styled } from "../../stitches.config"
import { useLocation, useNavigate } from 'react-router-dom';
import TipCallToAction from '../Modal/payment/TipCallToAction';

interface IAtavistTipProps {
    article: ArticleAuthor;
}

const AtavistTip: React.FC<IAtavistTipProps> = ({ article }) => {
    return (
        <Wrapper contentEditable={false}>
            <TipCallToAction
                headText={`Podobają Ci się moje artykuły? Możesz zostawić napiwek`}
                descriptionText="Teraz możesz docenić pracę dziennikarzy i dziennikarek. Cała kwota trafi do nich. Wraz z napiwkiem możesz przekazać też krótką wiadomość."
                articleOID={article.OID}
                users={article.allAuthors}
                origin={"tip-inline-atavist"}
            />
        </Wrapper>
    )
}

export default AtavistTip;

const Wrapper = styled("div", {
    backgroundColor: "#ffffff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "auto",
    maxWidth: '850px',
    margin: '20px 38px',
    userSelect: "none",
    h3: {
        margin: "0px",
    },
    '@bp4': {
        margin: 'auto',
    }
});